<template>
    <!--    派息審批-->
    <div>
        <vs-row vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span :class="isMobile() ? 'titleMob' : 'title'">{{$t("message.dividendApproval")}}</span>
            </vs-col>

        </vs-row>
        <vs-table :data="data" stripe pagination maxItems="15" class="scroll-table">
            <template slot="thead">
                <vs-th>
                    {{$t("message.customerCode")}}
                </vs-th>
                <vs-th>
                    {{$t("message.customerName")}}
                </vs-th>
                <vs-th>
                    {{$t("message.planName")}}
                </vs-th>
                <vs-th>
                    {{$t("message.dividendDate")}}
                </vs-th>
                <vs-th>
                    {{$t("message.interest1")}}
                </vs-th>
                <vs-th>
                    {{$t("message.manageFee1")}}
                </vs-th>
                <vs-th>
                    {{$t("message.grossInterest")}}
                </vs-th>
                <vs-th>
                    {{$t("message.accumulated")}}
                </vs-th>
                <vs-th>
                    {{$t('message.rolloverAmount')}}
                </vs-th>
                <vs-th style="min-width: 80px !important;">
                    {{$t("message.status")}}
                </vs-th>
                <vs-th></vs-th>
                <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <div v-if="tr.clientCode || (tr.plan.customer && tr.plan.customer.code)">
                            {{tr.clientCode ? tr.clientCode : tr.plan.customer.code}}
                        </div>
                    </vs-td>
                    <vs-td>
                        <div v-if="tr.clientName || (tr.plan.customer && tr.plan.customer.user && tr.plan.customer.user.name)">
                            {{tr.clientName ? tr.clientName : tr.plan.customer.user.name}}
                        </div>
                    </vs-td>
                    <vs-td>
                        <div v-if="tr.plan">
                            {{lang === 'en' ? tr.plan.name : tr.plan.name_zh}}
                        </div>
                    </vs-td>
                    <vs-td>
                        {{tr.datePayable | dateFormat}}
                    </vs-td>
                    <vs-td>
                        {{tr.interest | priceFormat}}
                    </vs-td>
                    <vs-td>
                        {{tr.managementFee | priceFormat}}
                    </vs-td>
                    <vs-td :data="tr.grossInterest">
                        {{tr.grossInterest | priceFormat}}
                    </vs-td>
                    <vs-td :data="tr.accumulated">
                        {{tr.accumulated | priceFormat}}
                    </vs-td>
                    <vs-td :data="tr.rolloverAmount">
                        {{tr.rolloverAmount | priceFormat}}
                    </vs-td>
                    <vs-td>
                        {{tr.status == 'on hold' ? $t('message.onHold') : $t(`message.${tr.status}`)}}
                    </vs-td>
                    <vs-td style="white-space: nowrap">
                        <div v-if="tr.status === 'pending'">
                            <vs-button v-role="['manager']" @click="onApproveOne(tr._id, 'approved')" size="small" color="rgb(37, 105, 193)" style="margin-right: 10px">
                                <feather-icon icon="CheckIcon"></feather-icon>
                                <span>{{$t('message.approve')}}</span>
                            </vs-button>
                            <vs-button v-role="['manager']" @click="onApproveOne(tr._id, 'rejected')" size="small" color="danger" style="margin-right: 10px">
                                <feather-icon icon="XIcon"></feather-icon>
                                <span>{{$t('message.reject')}}</span>
                            </vs-button>
                        </div>
                        <vs-button v-if="tr.type === 'Settlement' && tr.status === 'approved'" v-role="['admin']" @click="onComplete(tr._id)" size="small" color="rgb(37, 105, 193)">
                            {{$t('message.complete')}}
                        </vs-button>
                    </vs-td>
                    <vs-td>
                        <vs-button v-if="tr.status === 'rejected'" v-role="['admin']" @click="onEdit(tr)" size="small">
                            {{$t('message.edit')}}
                        </vs-button>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-popup :active.sync="updateFlag" title=" ">
            <EditDividend :data.sync="currentDividend" @update="onUpdate" />
        </vs-popup>

    </div>
</template>
<script>
import EditDividend from "@/components/EditDividend";
export default {
    name: 'dividendApproval',
    beforeRouteEnter(to,from,next){
        if($cookies.get('role') === 'admin' || $cookies.get('role') === 'manager'){
            next()
        }else if($cookies.get('role') === 'user'){
            next('/')
        }else if($cookies.get('role') === 'agent'){
            next('/customer')
        }
    },
    data(){
        return{
            token: '',
            lang: '',
            role: '',
            data: [],
            currentDividend: {},
            updateFlag: false,
        }
    },
    created() {
        this.token = this.$cookies.get('token');
        this.lang = this.$cookies.get('lang');
        this.role = this.$cookies.get('role');
        let url = process.env.VUE_APP_API_BASEURL + '/api/dividend?access_token=' + this.$cookies.get('token');
        fetch(url).then((res) => {
            return res.json()
        }).then((data) => {
            this.data = data.responseDetail.data;
        })
    },
    methods:{
        onReload(){
            let url = process.env.VUE_APP_API_BASEURL + '/api/dividend?access_token=' + this.$cookies.get('token');
            fetch(url).then((res) => {
                return res.json()
            }).then((data) => {
                this.data = data.responseDetail.data;
            })
        },
        onApproveOne(id, state){
            console.log(state)
            let url = process.env.VUE_APP_API_BASEURL + '/api/dividend/'+ id +'/approveOne?access_token=' + this.token;
            fetch(url, {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, *!/!*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    state: state
                })
            }).then((response) => {
                return response.json()
            }).catch((error) => {
                console.log(error);
            }).then((result) => {
                if(result.responseCode === 200){
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t(`message.${state}`),
                        icon: 'done',
                        color:'success',
                        position:'top-center',
                        time: 3000
                    });
                    this.onReload();
                }else{
                    this.$vs.notify({
                        title:'提示',
                        text: result.responseMsg + ". " + result.responseDetail,
                        icon: 'clear',
                        color:'danger',
                        position:'top-center',
                        time: 3000
                    });
                }
            });
        },
        onEdit(item){
            const customerCode = item.plan.customer ? item.plan.customer.code : '';
            const clientCode = item.clientCode;
            const customerName = item.plan.customer && item.plan.customer.user ? item.plan.customer.user.name : '';
            const clientName = item.clientName;
            this.currentDividend = {...item,
                clientCode: clientCode || customerCode,
                clientName: clientName || customerName,
                plan: (item.plan.name || item.plan.name_zh) ? this.lang === 'zh' ? item.plan.name_zh : item.plan.name : '',
            }
            this.updateFlag = true;
        },
        onUpdate(){
            let url = process.env.VUE_APP_API_BASEURL + '/api/dividend/' + this.currentDividend._id + '?access_token=' + this.token;
            fetch(url, {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, *!/!*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    datePayable: this.currentDividend.datePayable,
                    interest: Number(this.currentDividend.interest),
                    managementFee: Number(this.currentDividend.managementFee),
                    grossInterest: Number(this.currentDividend.grossInterest),
                    accumulated: Number(this.currentDividend.accumulated),
                    rolloverAmount: Number(this.currentDividend.rolloverAmount)
                })
            }).then((response) => {
                return response.json()
            }).catch((error) => {
                console.log(error);
            }).then((result) => {
                if(result.responseCode === 200){
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t('message.updateSuccess'),
                        icon: 'done',
                        color:'success',
                        position:'top-center',
                        time: 3000
                    });
                    this.updateFlag = false;
                    this.onReload();
                }else{
                    this.$vs.notify({
                        title:'提示',
                        text: result.responseMsg + ". " + result.responseDetail,
                        icon: 'clear',
                        color:'danger',
                        position:'top-center',
                        time: 3000
                    });
                }
            });
        },
        onComplete(id){
            let url = process.env.VUE_APP_API_BASEURL + '/api/dividend/'+ id +'/complete?access_token=' + this.token;
            fetch(url, {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, *!/!*',
                    'Content-Type': 'application/json'
                },
                body: null
            }).then((response) => {
                return response.json()
            }).catch((error) => {
                console.log(error);
            }).then((result) => {
                if(result.responseCode === 200){
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t('message.complete'),
                        icon: 'done',
                        color:'success',
                        position:'top-center',
                        time: 3000
                    });
                    this.onReload();
                }else{
                    this.$vs.notify({
                        title:'提示',
                        text: result.responseMsg + ". " + result.responseDetail,
                        icon: 'clear',
                        color:'danger',
                        position:'top-center',
                        time: 3000
                    });
                }
            });
        }

    },
    components: {
        EditDividend
    }
}
</script>
<style>
.scrollTable .vs-table--content{
    width: 1000px;
}
</style>
<style scoped>
.feather-icon{
    vertical-align: middle;
    margin-right: 3px;
    width: 1.2rem;
    height: 1.2rem;
}
.feather-icon svg{
    color: white;
}


</style>
